function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var performancePeriods = [{
  id: "M0",
  years: null,
  shortLabel: "Rentabilidad YTD",
  longLabel: "Rentabilidad en el año",
  tableLabel: "Año actual"
}, {
  id: "M12",
  years: 1,
  tableLabel: "12 meses"
}, {
  id: "M1",
  years: 1 / 12,
  tableLabel: "Último mes"
}, {
  id: "M24",
  years: 2,
  tableLabel: "24 meses"
}, {
  id: "M36",
  years: 3,
  tableLabel: "3 años"
}, {
  id: "M60",
  years: 5,
  tableLabel: "5 años"
}, {
  id: "M120",
  years: 10,
  tableLabel: "10 años"
}];
var statsLabels = {
  performance: {
    label: "Rentabilidad",
    tooltip: {
      title: "Rentabilidad",
      text: "Rentabilidad obtenida por el producto en un periodo de tiempo."
    }
  },
  alpha: {
    label: "Alpha",
    tooltip: {
      title: "Alpha",
      text: "Alpha."
    }
  },
  beta: {
    label: "Beta",
    tooltip: {
      title: "Beta",
      text: "Beta."
    }
  },
  maxDrawdown: {
    label: "Máxima caída",
    tooltip: {
      title: "Max drawdown",
      text: "Esta medida permite cuantificar la pérdida máxima que ha sufrido el capital invertido durante la fecha analizada"
    }
  },
  standardDeviation: {
    label: "Volatilidad",
    tooltip: {
      title: "Volatilidad",
      text: "Volatilidad."
    }
  },
  sharpeRatio: {
    label: "Ratio de Sharpe",
    tooltip: {
      title: "Beneficio en relación al riesgo asumido",
      text: "Es una medida que habla sobre la eficiencia del gestor. Qué rendimiento ha generado sobre el activo sin riesgo por cada unidad de riesgo asumida. En general, mayor de 1 es considerado muy positivo."
    }
  },
  trackingError: {
    label: "Tracking Error",
    tooltip: {
      title: "Tracking Error",
      text: "Mide los rendimientos de una cartera o de un fondo en concreto, poniéndolos en comparación con el mercado.",
      link: "https://www.finect.com/usuario/vanesamatesanz/articulos/que-tracking-error"
    }
  },
  correlation: {
    label: "Correlación",
    tooltip: {
      title: "Correlación",
      text: "Correlation."
    }
  },
  r2: {
    label: "R Cuadrado",
    tooltip: {
      title: "R Cuadrado",
      text: "R Cuadrado."
    }
  },
  informationRatio: {
    label: "Ratio de Información",
    tooltip: {
      title: "Ratio de Información",
      text: "Ratio de Información."
    }
  }
};
export var getPeriod = function getPeriod(period) {
  return performancePeriods.find(function (item) {
    return item.id === period;
  });
};
export var getStatLabel = function getStatLabel(stat, period, format) {
  var statData = statsLabels[stat];
  var periodData = performancePeriods.find(function (_ref) {
    var id = _ref.id;
    return id === period;
  });
  if (["stat"].includes(format)) {
    return statData.label;
  }
  if (!periodData) {
    return "".concat(statData.label, " ").concat(period);
  }
  if (["summary"].includes(format)) {
    return "".concat(statData.label, " ").concat(periodData.tableLabel);
  }
  if (["table"].includes(format)) {
    return [statData.label, periodData.tableLabel];
  }
};
export var getStatTooltip = function getStatTooltip(stat, period) {
  var statData = statsLabels[stat];
  var periodData = performancePeriods.find(function (_ref2) {
    var id = _ref2.id;
    return id === period;
  });
  if (!periodData) {
    return statData.tooltip;
  }
  return _objectSpread(_objectSpread({}, statData.tooltip), {
    title: "".concat(statData.tooltip.title, " ").concat(periodData.tableLabel)
  });
};
export var getPeriodPerformanceLabel = function getPeriodPerformanceLabel(period, format) {
  var performancePeriod = performancePeriods.find(function (_ref3) {
    var id = _ref3.id;
    return id === period;
  });
  if (!performancePeriod) {
    return null;
  }
  if (format === "summary" || performancePeriod.years < 1) {
    return "Rentabilidad (".concat(performancePeriod.tableLabel, ")");
  }
  if (format === "short" && performancePeriod.shortLabel) {
    return performancePeriod.shortLabel;
  }
  if (format === "long" && performancePeriod.longLabel) {
    return performancePeriod.shortLabel;
  }
  if (format === "short") {
    return "Rent. ".concat(performancePeriod.years, " a\xF1o").concat(performancePeriod.years > 1 ? "s" : "");
  }
  return "Rentabilidad a ".concat(performancePeriod.years, " a\xF1o").concat(performancePeriod.years > 1 ? "s" : "");
};